<template>
  <div class="contact-list" :class="`contact-list--${mode}`">
    <div class="contact-list__rows">
      <div v-for="contact in contacts" :key="`${contact.phone}-${contact.forum}`" class="contact-list__row">
        <span class="contact-list__forum" :title="contact.forum">{{ contact.forum }}</span>
        <a :href="`tel:${contact.phone}`" class="contact-list__link" :style="{ color }">
          <span class="contact-list__name">{{ contact.name }}</span>
          <span class="contact-list__phone">{{ contact.phone }}</span>
        </a>
      </div>
    </div>
    <p class="contact-list__hours" :style="{ color }">{{ consultationTime }}</p>
  </div>
</template>

<script>
const contacts = [
  { forum: '开幕式', name: '袁利民', phone: '13973161758' },
  { forum: 'AI+青年创业', name: '朱必红', phone: '18682241070' },
  { forum: 'AI+OpenCL异构计算', name: '郭旭辉', phone: '18673131737' },
  { forum: 'AI+数字内容', name: '刘媛', phone: '19507417759' },
  { forum: 'AI+具身智能', name: '黄翔', phone: '18874793633' },
  { forum: 'AI+脑机接口', name: '黃晶', phone: '17375803378' },
  { forum: 'AI+先进制造', name: '朱丽', phone: '18500022889' },
  { forum: 'AI+创新产业', name: '郝泽钰', phone: '15200914220' },
  { forum: 'AI项目投资路演', name: '丁灵敏', phone: '18932445057' },
  { forum: '技术支持', name: '许工', phone: '16670256305' }
]

export default {
  name: 'ContactList',
  props: {
    mode: {
      type: String,
      default: 'page',
      validator: value => ['page', 'dialog'].includes(value)
    },
    color: {
      type: String,
      default: '#3c97ed'
    }
  },
  data() {
    return {
      contacts,
      consultationTime: '咨询时间：周一至周五9:00-17:00'
    }
  }
}
</script>

<style lang="less" scoped>
.contact-list {
  width: 100%;
  color: #666;
  font-size: 12px;
}

.contact-list__row {
  min-width: 0;
  line-height: 1.5;
}

.contact-list__forum,
.contact-list__phone {
  white-space: nowrap;
}

.contact-list__link {
  text-decoration: none;
  white-space: nowrap;
}

.contact-list__hours {
  margin: 0;
}

.contact-list--page {
  .contact-list__rows {
    margin-top: 30px;
  }

  .contact-list__row {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
  }

  .contact-list__link {
    width: 140px;
    display: flex;
    justify-content: space-between;
  }

  .contact-list__name {
    width: 60px;
    display: inline-block;
  }

  .contact-list__hours {
    margin-top: 5px;
    line-height: 2;
  }
}

.contact-list--dialog {
  .contact-list__row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 8px;
  }

  .contact-list__forum {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .contact-list__link {
    width: 190px;
    min-width: 190px;
    display: grid;
    grid-template-columns: 52px minmax(0, 1fr);
    column-gap: 8px;
    align-items: center;
    text-align: left;
  }

  .contact-list__hours {
    margin: 2px 0;
  }
}
</style>
